import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';

import {CloInputText} from './text-input';
import {CloInputTextarea} from './textarea-input';
import {CloInputSelect} from './select-input';
import {CloInputSelectMultiple} from './select-multiple-input';
import {CloInputChoice, CloChoiceOption, CloChoiceLabel, CloRadioOption, CloCheckboxOption} from './choice-input';
import {CloDatePicker} from './date-input';
import {NgbDatepickerModule} from '../datepicker/datepicker.module';
import {DlDateTimePickerModule} from '../date-picker/dl-date-time-picker/dl-date-time-picker.module';
import {NgbDropdownModule} from '../dropdown/dropdown.module';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {CloInputCounter} from './counter-input';
import {NumbersOnlyDirective} from '../util/numbers-only.directive';

export {CloInputText} from './text-input';
export {CloInputTextarea} from './textarea-input';
export {CloInputSelect} from './select-input';
export {CloInputSelectMultiple} from './select-multiple-input';
export {CloInputChoice, CloChoiceOption, CloChoiceLabel, CloCheckboxOption, CloRadioOption} from './choice-input';
export {CloDatePicker} from './date-input';
export {CloInputCounter} from './counter-input';

const DIRECTIVES = [
  CloInputText, CloInputChoice, CloChoiceLabel, CloChoiceOption, CloDatePicker, CloInputTextarea, CloInputSelect, CloInputSelectMultiple,
  CloInputCounter, CloCheckboxOption, CloRadioOption, NumbersOnlyDirective
];

@NgModule(
  {

    declarations: DIRECTIVES,
    exports: [CloInputText, CloInputChoice, CloChoiceLabel, CloChoiceOption, CloDatePicker, CloInputTextarea,
      CloInputSelect, CloInputSelectMultiple, CloInputCounter, CloCheckboxOption, CloRadioOption],
    imports: [CommonModule, ReactiveFormsModule, NgbDatepickerModule, NgbDropdownModule, NgMultiSelectDropDownModule.forRoot(), FormsModule,
      BrowserModule, DlDateTimePickerModule],
    entryComponents: [CloInputText, CloInputChoice, CloDatePicker, CloInputTextarea, CloInputSelect, CloInputSelectMultiple,
      CloInputCounter]

  })

export class CloInputModule {


}
